var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"controls-position":"right","placeholder":_vm.placeholder},on:{"input":_vm.input},model:{value:(_vm.num),callback:function ($$v) {_vm.num=$$v},expression:"num"}})
}
var staticRenderFns = []

export { render, staticRenderFns }